import axios from 'axios';
import { apiUrl } from './lt-api';

const suppliersAPI = axios.create({
  baseURL: apiUrl,
  crossDomain: true,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json'
  }
});

suppliersAPI.interceptors.request.use((config) => {
  const token = JSON.parse(localStorage.getItem('token'));
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const getSuppliersApi = (params) => suppliersAPI.get('/suppliers', { params });
export const updateSuppliersApi = (id, payload) => suppliersAPI.put(`/suppliers/${id}`, payload);
export const getSupplierByIdApi = (id) => suppliersAPI.get(`/suppliers/${id}`);
export const getZonesApi = () => suppliersAPI.get('/zones');
